import { createFileRoute } from '@tanstack/react-router'
import LoginDeviceComplete from '@/components/pages/LoginDeviceComplete/LoginDeviceComplete'

export const Route = createFileRoute('/login/device/complete')({
  component: DeviceCompleteLoginRoute,
})

function DeviceCompleteLoginRoute() {
  return <LoginDeviceComplete />
}
